var _rect, _rect2, _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnailVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 5,
    fill: "url(#paint0_linear_4967_97262)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white",
    fillOpacity: 0.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7404 44.6225C48.409 43.7752 46.6667 44.7317 46.6667 46.3099V57.6898C46.6667 59.268 48.409 60.2244 49.7404 59.3771L58.6818 53.6872C59.9168 52.9013 59.9168 51.0984 58.6818 50.3125L49.7404 44.6225Z",
    fill: "#36D9D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 8,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 88,
    width: 5,
    height: 8,
    rx: 1,
    fill: "#FCFCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4967_97262",
    x1: -74.4726,
    y1: 132.99,
    x2: 62.3969,
    y2: -14.1391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailVideo);
export default __webpack_public_path__ + "static/media/thumbnail-video.64bb85947f8176c859235c8b989f1000.svg";
export { ForwardRef as ReactComponent };